import { PercentageBar } from 'features/Health/components/MonetisationHealthPercentageBars/MonetisationHealthPercentageBars';
import { HealthMetrics } from 'features/Health/containers/MonetisationHealthChartContainer/types/healthMetrics';
import { DELIVERY_COLOUR, DEMAND_COLOUR } from 'utils/colours';

export const percentageBars = (healthMetricData: HealthMetrics): PercentageBar[] => [
  {
    label: 'Demand Rate',
    value: healthMetricData.demand.overall,
    color: DEMAND_COLOUR,
  },
  {
    label: 'Delivery Rate',
    value: healthMetricData.delivery.overall,
    color: DELIVERY_COLOUR,
  },
];
